import React from 'react';
import { TableCell, TableRow, TextField, Autocomplete} from '@mui/material';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';
import styled from 'styled-components';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const AMeditablerow = ({k,row, subject, editFormData, handleCancelClick, tabledata, SubmitButton,
   page, rowsPerPage, onChangeEditCateg, assetCategory, assetmaster}) =>{
    return( <>
        <TableRow key={k} name={row.Category}>
           <TableCell component="th" scope="row">
           {(page)*(rowsPerPage)+k+1}
           </TableCell>
           
        <TableCell  align="left">
          <TextField
            id="outlined-basic"
            size='small'
            type="text"
            name={`Category`}
            onChange={(e) => onChangeEditCateg(e, k, row._id)}
            label="Category"
            value={editFormData[k]?.Category}
            variant="outlined"
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
          />
        </TableCell>
        <TableCell  align="left">
          {subject[`subject${(page)*(rowsPerPage)+k}`]?.data?.length? <TextField
            id="outlined-basic"
            size='small'
            type="text"
            name={'Subject'}
            onChange={(e) => onChangeEditCateg(e, k, row._id)}
            label="Subject"
            value={editFormData[k].Subject[subject[`subject${(page)*(rowsPerPage)+k}`]?.index]}
            variant="outlined"
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
          />:"Select Asset"}                

            </TableCell>
            
            <TableCell  align="left">
              <Autocomplete
                multiple
                id="combo-box-demo"
                size='small'
                options={assetmaster ? (Object.values(assetmaster)?.map(x=>x.Category)):[]}
                sx={{backgroundColor:"white", width:"250px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
                // getOptionLabel={(option) => option.title}
                value={editFormData[k]?.ApplAssetCateg}
                onChange={(e, newValue) =>onChangeEditCateg(e,k, row._id, newValue, "ApplAssetCateg")}
                renderInput={(params) => ( 
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Select Asset Categories"
                    placeholder="Select"
                  />
                )}
              />           
        </TableCell>

        <TableCell  align="left">
          <Autocomplete
            multiple
            id="combo-box-demo"
            size='small'
            options={(assetmaster && (!editFormData[k]?.AppAssets?.includes("All Assets")))? ["All Assets"].concat(Object.values(assetmaster)
              .filter(item => editFormData[k]?.ApplAssetCateg?.includes(item.Category))
              .flatMap(item => item.Asset.map(asset => asset.Name))):[]} 
            sx={{backgroundColor:"white", width:"250px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
            // getOptionLabel={(option) => option.title}
            value={editFormData[k]?.AppAssets}
            onChange={(e, newValue) => onChangeEditCateg(e,k, row._id, newValue, "AppAssets")}
            renderInput={(params) => ( 
              <TextField
                {...params}
                variant="outlined"
                label="Select Applicable Asset"
                placeholder="Select"
              />
            )}
          />           
        </TableCell>

            <TableCell align="left">
              <ButtonWrapper>
                <SubmitButton type="submit">Save</SubmitButton>
                <SubmitButton type="button" onClick={(e)=>handleCancelClick(e,k)}>Cancel</SubmitButton>
              </ButtonWrapper>                           
            </TableCell>
          </TableRow>     
        </>         
    )
}

export default AMeditablerow;